import { ApiService } from "pwapi";

import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

import {
  CREATE_LIS_INSURANCE_FAILURE,
  CREATE_LIS_INSURANCE_REQUEST,
  CREATE_LIS_INSURANCE_SUCCESS,
  DELETE_LIS_INSURANCE_FAILURE,
  DELETE_LIS_INSURANCE_REQUEST,
  DELETE_LIS_INSURANCE_SUCCESS,
  UPDATE_LIS_INSURANCE_FAILURE,
  UPDATE_LIS_INSURANCE_REQUEST,
  UPDATE_LIS_INSURANCE_SUCCESS,
  UPDATE_LIS_LOCATION_FAILURE,
  UPDATE_LIS_LOCATION_REQUEST,
  UPDATE_LIS_LOCATION_SUCCESS,
  UPDATE_LIS_PATIENT_FAILURE,
  UPDATE_LIS_PATIENT_REQUEST,
  UPDATE_LIS_PATIENT_SUCCESS,
} from "../constants";

interface updatePatientArgs {
  id: number;
  requestBody: any;
}

type updateInsuranceArgs = {
  id: number;
  requestBody: any;
};
type createInsuranceArgs = Parameters<
  typeof ApiService.createAdminInsurance
>[0];
type deleteInsuranceArgs = Parameters<
  typeof ApiService.destroyAdminInsurance
>[0];

export const updatePatient: AsyncSagaAction<updatePatientArgs> =
  createAsyncSaga(
    UPDATE_LIS_PATIENT_REQUEST,
    UPDATE_LIS_PATIENT_SUCCESS,
    UPDATE_LIS_PATIENT_FAILURE,
    ({ id }: updatePatientArgs) => `admin/patient/${id}/update`,
    ({ id, requestBody }: updatePatientArgs) =>
      ApiService.partialUpdateAdminPatient({
        id,
        requestBody,
      })
  );

export const updatePatientAddress: AsyncSagaAction<updatePatientArgs> =
  createAsyncSaga(
    UPDATE_LIS_LOCATION_REQUEST,
    UPDATE_LIS_LOCATION_SUCCESS,
    UPDATE_LIS_LOCATION_FAILURE,
    ({ id }: updatePatientArgs) => `admin/location/${id}/update`,
    ({ id, requestBody }: updatePatientArgs) =>
      ApiService.partialUpdateLocation({
        id,
        requestBody,
      })
  );

export const updateInsurance: AsyncSagaAction<updateInsuranceArgs> =
  createAsyncSaga(
    UPDATE_LIS_INSURANCE_REQUEST,
    UPDATE_LIS_INSURANCE_SUCCESS,
    UPDATE_LIS_INSURANCE_FAILURE,
    ({ id }: updateInsuranceArgs) => `admin/insurance/${id}/update`,
    ({ id, requestBody }: updateInsuranceArgs) =>
      ApiService.partialUpdateAdminInsurance({
        id,
        requestBody,
      })
  );

export const createInsurance: AsyncSagaAction<createInsuranceArgs> =
  createAsyncSaga(
    CREATE_LIS_INSURANCE_REQUEST,
    CREATE_LIS_INSURANCE_SUCCESS,
    CREATE_LIS_INSURANCE_FAILURE,
    () => `admin/insurance/create`,
    ({ requestBody }: createInsuranceArgs) =>
      ApiService.createAdminInsurance({
        requestBody,
      })
  );

export const deleteInsurance: AsyncSagaAction<deleteInsuranceArgs> =
  createAsyncSaga(
    DELETE_LIS_INSURANCE_REQUEST,
    DELETE_LIS_INSURANCE_SUCCESS,
    DELETE_LIS_INSURANCE_FAILURE,
    ({ id }: deleteInsuranceArgs) => `insurance/${id}/delete`,
    ({ id }: deleteInsuranceArgs) =>
      ApiService.destroyAdminInsurance({
        id,
      })
  );
